export const OpenLinkIcon = () => {
	return (
		<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.57344 2.22561V3.4115H1.3067V9.93388H8.49353V6.96916H9.80023V10.5268C9.80023 10.6841 9.7314 10.8349 9.60887 10.9461C9.48634 11.0573 9.32016 11.1198 9.14688 11.1198H0.653349C0.48007 11.1198 0.313888 11.0573 0.191361 10.9461C0.0688347 10.8349 0 10.6841 0 10.5268V2.81855C0 2.66129 0.0688347 2.51048 0.191361 2.39928C0.313888 2.28808 0.48007 2.22561 0.653349 2.22561H4.57344ZM11.7603 0.446777V5.19033H10.4536V2.47049L5.36203 7.0919L4.4382 6.25348L9.52909 1.63266H6.53349V0.446777H11.7603Z"
				fill="#5770F6"
			/>
		</svg>
	);
};
